<template>
  <header class="header">
    <div :class="{ 'account-menu': true, 'is-show': showMenu }" id="accountMenu">
      <div class="heading">
        <button class="close-menu" type="button" id="accountMenuClose" @click="showMenu = false">
          <i class="bi bi-x-circle"></i>
        </button>
        <div class="d-flex justify-content-between align-items-center mb-3">
          <span class="hi montserrat-bold">¡Hola!</span>
          <button @click="logoutHeader" class="signout btn rounded-pill text-uppercase montserrat-semibold">Cerrar
            sesión</button>
        </div>
        <div class="d-flex flex-column">
          <span class="name text-uppercase">{{ user.razSocial }}</span>
          <span class="email">{{ user.mailFacElec }}</span>
        </div>
      </div>
      <div class="content" v-if="false">
        <ul>
          <li><a href="" class="link montserrat-semibold">Mi perfil</a></li>
          <li><a href="" class="link montserrat-semibold">Mis pedidos</a></li>
          <li>
            <a href="" class="link montserrat-semibold">Estado de cuenta</a>
          </li>
          <li>
            <a href="" class="link montserrat-semibold">Solicitud Garantía y Soporte Técnico (RMA)</a>
          </li>
          <li>
            <a href="" class="link montserrat-semibold">Solicitud Anulaciones y Devoluciones</a>
          </li>
          <li>
            <a href="" class="link montserrat-semibold">Consultas e Incidencias</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="top-header py-3">
      <div class="container-lg">
        <div class="row text-center">
          <div class="register-text col-auto text-uppercase text-white montserrat-semibold">
            <span class="d-none d-md-block">Si eres cliente nuevo, puedes <router-link to="/registrarse"
                class="text-white text-decoration-underline">registrarte aquí</router-link></span>
            <span class="d-md-none">¿Cliente nuevo? <router-link to="/registrarse"
                class="text-white text-decoration-underline">regístrate aquí</router-link></span>
          </div>
          <div class="links col-auto ms-auto text-uppercase montserrat-semibold d-none d-md-block">
            <ul class="list-inline mb-0 d-flex">
              <li class="list-inline-item"><span class="text-white text-decoration-none">Nexus Corporativo</span>
              </li>
              <li class="list-inline-item"><span class="text-white text-decoration-none">Nexus Academy</span></li>
              <li class="list-inline-item cursor-pointer" @click="redirect('contactanos')"><span class="text-white text-decoration-none">Contáctanos</span></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="main-header py-3 py-md-4 pb-0">
      <div class="main-header__content container-lg d-flex align-items-center justify-content-between">
        <div class="logo order-1">
          <router-link to="/" class="w-100"><img src="@/assets/catalogo/logo.svg" alt="Nexus Technology" /></router-link>
        </div>
        <div class="search-container search d-flex align-items-center order-3 order-lg-2"
          v-click-outside="closeListbox">
          <div class="menu-mobile d-lg-none">
            <button type="button" class="btn me-3 js-button-main-menu" @click="toggleMenu">
              <i class="bi bi-list"></i>
            </button>
          </div>
          <form class="search-form d-flex align-items-center border rounded-pill overflow-hidden w-100" @submit.prevent>
            <InputText v-model="searchQuery" @input="handleInput" @keypress.enter="verMasProductos"
              placeholder="Encuentra el producto que deseas" class="search__input form-control border-0 py-2" />
            <label for="searchInput" class="search__icon cursor-pointer" @click="verMasProductos"><i
                class="bi bi-search"></i></label>
          </form>
          <div v-if="searchResults.length" class="search-results">
            <Listbox v-model="selectedItem" :options="searchResults" optionLabel="nombre" @change="selectResult()"
              class="w-100">
              <template #option="slotProps">
                <div class="listbox-item d-flex align-items-center p-2">
                  <img :src="slotProps.option.fotos.principal" alt="Product Image" class="product-image" />
                  <div class="product-info">
                    <div class="product-name">{{ slotProps.option.nombre }}</div>
                    <div class="product-description">{{ slotProps.option.codigo }}</div>
                    <div class="product-description">{{ slotProps.option.descripcion }}</div>
                  </div>
                </div>
              </template>
              <template #footer>
                <div class="listbox-footer d-flex justify-content-center p-2">
                  <button @click="verMasProductos" class="btn">Ver más productos</button>
                </div>
              </template>
            </Listbox>
          </div>
        </div>
        <div class="user-menu montserrat-semibold text-uppercase order-2 order-lg-3">
          <ul class="list-inline mb-0 d-flex align-items-center">
            <li class="order-3 order-md-1">
              <a href="/login"
                class="text-decoration-none cursor-pointer d-flex align-items-center montserrat-semibold text-uppercase"
                @click.prevent="redirectlogin"><i class="bi bi-person"></i> <span class="d-none d-xl-block">Mi
                  cuenta</span></a>
            </li>
            <li class="order-2">
              <button class="link text-decoration-none d-flex align-items-center montserrat-semibold text-uppercase"
                type="button" id="userMenuCart" @click="showCarrito = true">
                <i class="bi bi-cart2"></i>
                <span class="d-none d-xl-block">Mi carro</span>
                <span class="extra">({{ productos.length }})</span>
              </button>
            </li>
            <li class="d-flex align-items-center order-1 order-md-3">
              <span class="d-none d-xl-block">Compra en</span>
              <div class="currencies d-flex align-items-center rounded-pill ms-2">
                <a @click="cambiarMoneda('ext')" class="cursor-pointer"
                  :class="['py-1 text-center rounded-pill inter-bold text-decoration-none', { 'is-active': selectedCurrency === 'ext' }]">
                  $
                </a>
                <a @click="cambiarMoneda('local')" class="cursor-pointer"
                  :class="['py-1 text-center rounded-pill inter-bold text-decoration-none', { 'is-active': selectedCurrency === 'local' }]">
                  S/.
                </a>
              </div>
            </li>
          </ul>
        </div>
        <div class="minicart rounded" id="miniCart" :class="{ 'is-show': (showCarrito && isLoggedIn) }">
          <div class="text-end mb-3">
            <button class="button-close" type="button" id="miniCartClose" @click="showCarrito = false">
              <i class="bi bi-x-lg"></i>
            </button>
          </div>
          <h3 class="title montserrat-semibold">Bolsa de compra ({{ productos.length }})</h3>
          <div class="items d-flex flex-column">
            <div class="item d-flex gap-3" v-for="(producto, index) in productos" :key="index">
              <div class="image">
                <img :src="producto.producto.fotos.principal" alt="" />
              </div>
              <div class="description d-flex flex-column justify-content-between">
                <span class="name montserrat-medium">{{ producto.producto.descripcion }}</span>
                <div class="d-flex justify-content-between align-items-center">
                  <span class="price montserrat-bold" v-if="selectedCurrency == 'local'">S/ {{
                    formatPrice(producto.producto.precio_local_sin_igv) }}</span>
                  <span class="price montserrat-bold" v-if="selectedCurrency == 'ext'">$ {{
                    formatPrice(producto.producto.precio_ext_sin_igv) }}</span>
                  <a @click="quitarProductoCarrito(producto)" class="button-remove"><i class="bi bi-trash3"></i></a>
                </div>
              </div>
            </div>
          </div>
          <div class="buttons text-center">
            <router-link to="/carrito" @click="showCarrito = false" class="btn montserrat-semibold rounded-pill">Ver
              bolsa /
              pagar</router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-header py-3 d-none d-md-block">
      <div class="container-lg position-relative">
        <div class="row align-items-center">
          <div class="col-auto">
            <nav class="menu">
              <ul>
                <li>
                  <button class="btn js-button-main-menu" @click="toggleMenu">
                    <span class="text">Menu de<br />Productos</span>
                    <i class="icon bi bi-list"></i>
                  </button>
                </li>
                <li>
                  <router-link to="/promociones?chkPromo=1"
                    class="link-button-promociones montserrat-semibold text-uppercase text-decoration-none">
                    Promociones
                  </router-link>
                </li>
                <li>
                  <router-link to="/liquidacion?chkOutlet=1"
                    class="montserrat-semibold text-uppercase text-decoration-none">
                    Liquidación
                  </router-link>
                </li>
                <li>
                  <router-link to="/marcas"
                    class="montserrat-semibold text-uppercase text-decoration-none">Marcas</router-link>
                </li>
                <li>
                  <router-link to="/eventos"
                    class="montserrat-semibold text-uppercase text-decoration-none">Eventos</router-link>
                </li>
                <li>
                  <router-link to="/preguntas-frecuentes"
                    class="montserrat-semibold text-uppercase text-decoration-none">Ayuda</router-link>
                </li>
                <li>
                  <router-link to="/novedades"
                    class="montserrat-semibold text-uppercase text-decoration-none">Novedades</router-link>
                </li>
              </ul>
            </nav>
          </div>
          <div class="links col-auto ms-auto text-uppercase montserrat-semibold">
            <ul class="list-inline mb-0 d-flex gap-4">
              <li class="list-inline-item">
                <router-link to="/catalogo"
                  class="link-catalog-morado montserrat-semibold text-uppercase text-decoration-none rounded-pill py-2 px-5 text-white">Ver
                  catálogo</router-link>
              </li>
              <li class="list-inline-item">
                <router-link to="/quiero-cotizacion"
                  class="link-catalog montserrat-semibold text-uppercase text-decoration-none rounded-pill py-2 px-5 text-white">Cotiza ahora</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="container-lg position-relative js-menu-products-container">
      <div :class="{ 'main-menu': true, 'is-show': menuActive, 'top-menu' : menuActive }" id="MainMenu">
        <nav>
          <div class="main-menu-mobile d-lg-none" id="MainMenuMobile" :class="{'is-hide': menuActiveLineasMobile}">
            <ul>
              <li><button class="btn btn--menu-products item" id="ButtonMenuProducts" @click="menuActiveLineasMobile = true">Menu de Productos</button></li>
              <li>
                <router-link to="/promociones?chkPromo=1"
                  class="item">
                  Promociones
                </router-link>
              </li>
              <li>
                <router-link to="/liquidacion?chkOutlet=1"
                  class="item">
                  Liquidación
                </router-link>
              </li>
              <li>
                <router-link to="/eventos"
                  class="item">Eventos</router-link>
              </li>
              <li>
                <router-link to="/marcas"
                  class="item">Marcas</router-link>
              </li>
              <li>
                <router-link to="/preguntas-frecuentes"
                  class="item">Ayuda</router-link>
              </li>
              <li>
                  <router-link to="/novedades"
                    class="item">Novedades</router-link>
                </li>
            </ul>
          </div>
          <div :class="{'menu-products': true , 'is-show': menuActiveLineasMobile}" id="MenuProducts">
            <div class="d-lg-none menu-products-mobile" id="MenuProductsMobile">
              <MenuNavegacion :menuCategoria="menuCategoria" @navigationStackEmpty="menuActiveLineasMobile = false"/>
            </div>
            <div class="d-none d-lg-block menu-products-desktop">
              <ul class="submenu submenu--1">
                <li class="has-submenu" v-for="categoria in menuCategoria" :key="categoria.categoria.codigo">
                  <div class="item"><a :href="categoria.url_filtro" class="link text-uppercase">{{categoria.categoria.descripcion}}</a></div>
                  <ul class="submenu submenu--2">
                    <li class="has-submenu" v-for="linea in categoria.lineas" :key="linea.linea.codigo">
                      <div class="item"><a :href="linea.url_filtro" class="link">{{ linea.linea.descripcion }}</a></div>
                      <ul class="submenu submenu--3">
                        <li class="has-submenu" v-for="sublinea in linea.sublineas" :key="sublinea.sublinea.codigo">
                          <div class="item"><a :href="sublinea.url_filtro" class="link">{{ sublinea.sublinea.descripcion }}</a></div>
                          <ul class="submenu submenu--4">
                            <li v-for="familia in sublinea.familias" :key="familia.familia.codigo">
                              <div class="item"><a :href="familia.url_filtro" class="link">{{ familia.familia.descripcion }}</a></div>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <div class="item"><a href="" class="link">Ver catálogo</a></div>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { ProductoService } from '@/services/ProductoService.js'
import { CategoriaService } from '@/services/CategoriaService.js'
import { formatPrice } from '@/helpers/utils.js'
import MenuNavegacion from '@/components/catalogo/common/menu-mobile.vue'
export default {
  components: {
    MenuNavegacion
  },
  data () {
    return {
      searchQuery: '',
      searchResults: [],
      productoService: new ProductoService(),
      categoriaService: new CategoriaService(),
      showCarrito: false,
      showMenu: false,
      menuCategoria: [],
      menuActive: false,
      menuActiveLineasMobile: false
    }
  },
  computed: {
    ...mapState({
      selectedCurrency: state => state.carrito.selectedCurrency,
      productos: state => state.carrito.productos,
      isLoggedIn: state => state.user.isLoggedIn,
      user: state => state.user.data
    })
  },
  methods: {
    formatPrice,
    handleInput () {
      if (this.searchQuery.length >= 2) {
        this.searchProducts()
      } else {
        this.buscarProductos('')
        this.searchResults = []
      }
    },
    async searchProducts () {
      const paramsPromociones = {
        search: this.searchQuery,
        limit: 5
      }
      this.productoService.getSearchProductos(paramsPromociones).then((data) => {
        this.searchResults = data
      })
    },
    selectResult () {
      this.searchQuery = ''
      this.$router.push({ path: '/producto', query: { codigo: this.selectedItem.codigo } })
    },
    ...mapActions({
      setCurrency: 'carrito/cambiarMoneda',
      quitarProducto: 'carrito/quitarProducto',
      buscarProductos: 'user/setUserProductSearch',
      logout: 'user/logout'
    }),
    cambiarMoneda (moneda) {
      this.setCurrency(moneda)
    },
    quitarProductoCarrito (producto) {
      this.quitarProducto(producto)
    },
    closeListbox () {
      this.searchResults = []
    },
    verMasProductos () {
      if (this.searchQuery.length >= 2) {
        this.closeListbox()
        this.buscarProductos(this.searchQuery)
        this.$router.push({ path: '/catalogo', query: { search: this.searchQuery } })
        this.searchQuery = ''
      }
    },
    redirectlogin () {
      if (this.isLoggedIn) {
        this.showMenu = !this.showMenu
      } else {
        this.$router.push({ path: '/login' })
      }
    },
    logoutHeader () {
      this.showMenu = false
      this.logout()
      this.$router.push({ path: '/' })
    },
    getMenu () {
      this.categoriaService.getMenuCategorias().then((data) => {
        this.menuCategoria = data
        this.currentMenu = data
      })
    },
    toggleMenu () {
      this.menuActive = !this.menuActive
    },
    redirect (url) {
      this.$router.push({ path: '/' + url })
    }
  },
  mounted () {
    const savedCurrency = this.selectedCurrency
    if (savedCurrency) {
      this.setCurrency(savedCurrency)
    }
    this.getMenu()
  },
  directives: {
    clickOutside: {
      mounted (el, binding) {
        el.clickOutsideEvent = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event)
          }
        }
        document.addEventListener('click', el.clickOutsideEvent)
      },
      unmounted (el) {
        document.removeEventListener('click', el.clickOutsideEvent)
      }
    }
  },
  watch: {
    menuActive (newValue) {
      if (newValue) {
        document.body.classList.add('show-menu-products')
      } else {
        document.body.classList.remove('show-menu-products')
      }
    }
  }
}
</script>
<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.search {
  max-width: 100%;
  width: 100%;
}

@media (min-width: 992px) {
  .header .main-header__content .search {
    max-width: 400px !important;
  }
}

@media (min-width: 768px) {
  .search {
    max-width: 400px;
  }
}
.search-container {
  width: 100%;
  max-width: 100%;
  position: relative;
  padding: 0 15px; /* Add padding to prevent touching screen edges */
}

.search-form {
  width: 100%;
}

.search__input {
  width: 100%;
  box-sizing: border-box;
}

.search__input:focus {
  outline: none !important;
}

.search-results {
  position: absolute;
  left: 15px;
  right: 15px;
  z-index: 1000;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-height: 300px;
  overflow-y: auto;
  margin-top: 345px;
}

.listbox-item {
  transition: background-color 0.2s;
}

.listbox-item:hover {
  background-color: #f5f5f5;
}

.product-image {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 4px;
  flex-shrink: 0;
}

.product-info {
  flex-grow: 1;
  min-width: 0; /* Allows text to wrap instead of expanding container */
  margin-left: 10px;
}

.product-name {
  font-weight: bold;
  font-size: 0.9rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.product-description {
  font-size: 0.8rem;
  color: #666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.product-price {
  font-weight: bold;
  font-size: 0.9rem;
}

@media (min-width: 768px) {
  .search-container {
    max-width: 400px;
  }
}

.size-h1 {
  font-size: 14px !important;
  margin-bottom: 0px !important;
  font-weight: 600;
}
.top-menu {
  top: 172.083px;
}

.link-catalog-morado {
  background-color: #7A266A;
}

.link-button-promociones {
  color:#F64C33;
}

.menu > ul > li > .btn .text {
  color: #113972 !important;
}

.menu > ul > li:not(:last-child, :first-child)::after {
  background-color: #113972 !important;
}
</style>
